import { observer } from "mobx-react-lite";
import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import { Input } from "../../../../../../components/inputs/input/input";
import { ShippingLabelSettingsStore } from "../../../../stores/shipping-label-settings-store";
import { TRACKING_TYPE } from "../../../../return-method-types";
import { NOTE_TYPE, Note } from "../../../../../../components/note/note";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import IconCopy from "../../../../../../components/icons/icon-copy/icon-copy";

interface ITrackingFieldsProps {
    shippingLabelStore?: ShippingLabelSettingsStore;
}

const TrackingTypeFields: React.FC<ITrackingFieldsProps> = observer(({shippingLabelStore}: ITrackingFieldsProps) => {

    const trackingType = shippingLabelStore?.getTrackingType();
    const webhookUrl = shippingLabelStore?.getTrackingWebhookUrl();

    return (
        <>
            <FormFieldLine label="Return Tracking" >
                    <Input disabled={true} value={trackingType} />
                </FormFieldLine>
                { shippingLabelStore?.showTrackingNote() &&
                    <FormFieldLine label="" >
                        <Note
                            type={NOTE_TYPE.INFORMATION} 
                            body={ 
                                trackingType === TRACKING_TYPE.TRACKING_TYPE_NOT_SUPPORTED 
                                    ? <FontBody2>{shippingLabelStore?.getTrackingNoteContent()}</FontBody2>
                                    : <FontBody2>Please contact us via <a href={'mailto:support@returngo.ai'} target="_blank" rel="noreferrer">email</a> or chat to be added to the shipment update service.</FontBody2>
                            } 
                        />
                    </FormFieldLine>
                }
                { shippingLabelStore?.showTrackingWebhook() &&
                    <>
                        <FormFieldLine label="Webhook Listener URL" >
                            <Input value={webhookUrl}
                                disabled={true}
                                button={{
                                    iconComp:()=><IconCopy/>,
                                    onClick:() => {navigator.clipboard.writeText(webhookUrl ?? '');}
                                }}
                            />
                        </FormFieldLine>
                        { shippingLabelStore?.getTrackingHelpLink() &&
                            <FormFieldLine label="" >
                                <Note type={NOTE_TYPE.INFORMATION} 
                                    body={ 
                                        <FontBody2>
                                            Click <a href={`${shippingLabelStore?.getTrackingHelpLink()}`} target="_blank" rel="noreferrer">here</a> to learn how to enable the tracking in your {shippingLabelStore?.getAggregtorLabel()} account.
                                        </FontBody2>    
                                    } 
                                />
                            </FormFieldLine>
                        }
                    </>
                }
        </>
    )
})

export default TrackingTypeFields;